/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type GetGooseGameItemsQueryVariables = Types.Exact<{
  eventId: Types.Scalars["Float"];
}>;

export type GetGooseGameItemsQuery = {
  gooseGameStoreItems: Array<
    Pick<
      Types.GooseGameItem,
      | "id"
      | "name"
      | "description"
      | "image_url"
      | "point_cost"
      | "quantity_available"
      | "user_redemption_limit"
      | "created_at"
      | "is_sold_out"
    >
  >;
};

export const GetGooseGameItemsDocument = gql`
  query GetGooseGameItems($eventId: Float!) {
    gooseGameStoreItems(event_id: $eventId) {
      id
      name
      description
      image_url
      point_cost
      quantity_available
      user_redemption_limit
      created_at
      is_sold_out
    }
  }
`;

/**
 * __useGetGooseGameItemsQuery__
 *
 * To run a query within a React component, call `useGetGooseGameItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGooseGameItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGooseGameItemsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetGooseGameItemsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetGooseGameItemsQuery,
    GetGooseGameItemsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetGooseGameItemsQuery,
    GetGooseGameItemsQueryVariables
  >(GetGooseGameItemsDocument, baseOptions);
}
export function useGetGooseGameItemsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetGooseGameItemsQuery,
    GetGooseGameItemsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetGooseGameItemsQuery,
    GetGooseGameItemsQueryVariables
  >(GetGooseGameItemsDocument, baseOptions);
}
export type GetGooseGameItemsQueryHookResult = ReturnType<
  typeof useGetGooseGameItemsQuery
>;
export type GetGooseGameItemsLazyQueryHookResult = ReturnType<
  typeof useGetGooseGameItemsLazyQuery
>;
export type GetGooseGameItemsQueryResult = ApolloReactCommon.QueryResult<
  GetGooseGameItemsQuery,
  GetGooseGameItemsQueryVariables
>;
